import { render, staticRenderFns } from "./NourishedPlanManagement.vue?vue&type=template&id=321ff476&scoped=true"
import script from "./NourishedPlanManagement.vue?vue&type=script&lang=js"
export * from "./NourishedPlanManagement.vue?vue&type=script&lang=js"
import style0 from "./NourishedPlanManagement.vue?vue&type=style&index=0&id=321ff476&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "321ff476",
  null
  
)

export default component.exports